var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slide carousel-wrapper" },
    [
      _c(
        "slick",
        { ref: "slick", attrs: { options: _vm.slickOptions } },
        _vm._l(_vm.slides, function (i, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "img-wrapper",
              on: {
                click: function ($event) {
                  return _vm.viewSlide(i)
                },
              },
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "slide__image",
                  attrs: { to: "", href: i.url, title: i.tool_tip },
                },
                [_c("img", { attrs: { width: "100%", src: i.image } })]
              ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }